import { render, staticRenderFns } from "./UserOperations.vue?vue&type=template&id=be7ba2fa&scoped=true"
import script from "./UserOperations.vue?vue&type=script&lang=js"
export * from "./UserOperations.vue?vue&type=script&lang=js"
import style0 from "./UserOperations.vue?vue&type=style&index=0&id=be7ba2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7ba2fa",
  null
  
)

export default component.exports